import useEmblaCarousel from "embla-carousel-react";

import Card from "../../components/Cards";
import { services } from "../../data/services";

import "./Portifolio.css";

export default function Portifolio() {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    align: "start",
    slidesToScroll: 1,
  });

  const scrollPrev = () => {
    emblaApi?.scrollPrev();
  };

  const scrollNext = () => {
    emblaApi?.scrollNext();
  };

  return (
    <section id="portifolio">
      <h2>Nossos Serviços</h2>

      <div className="embla">

        <div className="embla__viewport" ref={emblaRef}>

          <div className="embla__container">

            {services.map((s) => (
              <div className="embla__slide" key={s.id}>
                <Card
                  title={s.title}
                  features={s.features}
                  imagem={s.image}
                  alt={s.alt}
                  textoWpp={s.textoWpp}
                />
              </div>
            ))}

          </div>
        </div>

        <button
          className="arrow left"
          onClick={scrollPrev}
          aria-label="Serviço anterior"
        >
          ❮
        </button>

        <button
          className="arrow right"
          onClick={scrollNext}
          aria-label="Próximo serviço"
        >
          ❯
        </button>

      </div>
    </section>
  );
}